import http from "../utils/http";
import { toast } from "../utils/toast";

// 거래명세서 목록 조회
export const getInvoiceList = (invoiceType, body) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/invoices/list/${invoiceType}`, body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 거래명세서 등록
export const createInvoices = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/invoices", body)
      .then((res) => {
        toast.success("거래명세서가 등록되었습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 거래명세서 삭제
export const deleteInvoices = (invoiceIdx) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/invoices/${invoiceIdx}`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
// 거래명세서 목록 삭제
export const deleteInvoicesList = (invoiceIdxes) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/invoices`, {
        data: {
          invoiceIdxes
        }
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 거래명세서 수정
export const modifyInvoices = (invoiceIdx, body) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/invoices/${invoiceIdx}`, body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 거래명세서 조회
export const getInvoices = (idx) => {
  return new Promise((resolve, reject) => {
    http
      .get(`/invoices/${idx}`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 거래명세서 세금계산서 일괄 매핑
export const createInvoiceMappingTaxInvoice = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/invoices/mapping/tax-invoices`, body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
// 거래명세서 세금계산서 매핑 삭제
export const deleteInvoiceMappingTaxInvoice = (data) => {
  return new Promise((resolve, reject) => {
    http
      .delete('/invoices/mapping/tax-invoices', { data })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 세금계산서 목록 조회
export const getTaxInvoiceList = (
  supByrType,
  invoiceType,
  body
) => {
  return new Promise((resolve, reject) => {
    http
      .post(
        `/tax-invoices/list/${supByrType}/${invoiceType}`,
        body
      )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 세금계산서 엑셀다운로드
export const getTaxInvoiceExcel = (
  supByrType,
  invoiceType,
  body
) => {
  return new Promise((resolve, reject) => {
    http
      .post(
        `/tax-invoices/excel/${supByrType}/${invoiceType}`, body, {
        responseType: "arraybuffer",
      }
      )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 세금계산서 품목별 엑셀다운로드
export const getTaxInvoiceItemExcel = (
  supByrType,
  invoiceType,
  body
) => {
  return new Promise((resolve, reject) => {
    http
      .post(
        `/tax-invoices/item/excel/${supByrType}/${invoiceType}`, body, {
        responseType: "arraybuffer",
      }
      )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 세금계산서 상세
export const getTaxInvoice = (idx) => {
  return new Promise((resolve, reject) => {
    http
      .get(`/tax-invoices/${idx}`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 세금 계산서 발행
export const createTaxInvoicesIssue = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/tax-invoices/issue", body)
      .then((res) => {
        toast.success("전자(세금)계산서가 발행되었습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 거래명세서 품목 샘플 파일 다운로드
export const getInvoiceItemsExcelSample = () => {
  return new Promise((resolve, reject) => {
    http
      .get("/invoice-items/excel/sample")
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 거래명세서로 세금계산서 발행  taxInvoiceType = tax_invoice, receipt
export const createTaxInvoicesByInvoice = (invoiceIdx, taxInvoiceType) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/invoices/${invoiceIdx}/issue/${taxInvoiceType}`)
      .then((res) => {
        toast.success("세금계산서가 발급되었습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 세금계산서로 거래명세서 발급
export const createInvoiceByTaxInvoice = (taxInvoiceIdx, clientIdx) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/invoices/tax-invoice/${taxInvoiceIdx}/clients/${clientIdx}`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 세금계산서에 거래처 매핑
export const mappingTaxInvoiceClient = (taxInvoiceIdx, clientIdx) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/tax-invoices/${taxInvoiceIdx}/client/${clientIdx}`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 세금계산서 거래처 매핑 제거
export const deleteMappingTaxInvoiceClient = (taxInvoiceIdx) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/tax-invoices/${taxInvoiceIdx}`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 엑셀 다운로드
export const getInvoiceExcel = (supByrType, body) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/invoices/excel/${supByrType}`, body, {
        responseType: "arraybuffer",
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getInvoiceItemExcel = (supByrType, body) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/invoices/item/excel/${supByrType}`, body, {
        responseType: "arraybuffer",
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const excelUploadInvoice = (type, tax, file) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/invoices/excelupload/${type}/${tax}`, file)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 거래명세서 현금영수증 매핑
export const mappingCashReceipts = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post('/invoices/mapping/cash-receipts', body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 거래명세서 현금영수증 매핑 삭제
export const deleteMappingCashReceipts = (body) => {
  return new Promise((resolve, reject) => {
    http
      .delete('/invoices/mapping/cash-receipts', {
        data: body,
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

/**
 * 견적서, 발주서
 */

// 견적서/발주서 등록
export const createEtcInvoices = (params) => {
  return new Promise((resolve, reject) => {
    http.post("/etcInvoice", params)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      })
      ;
  });
};

// 견적서/발주서 목록 조회
export const getEtcInvoiceList = (type, body) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/etcInvoice/list/${type}`, body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
// 견적서/발주서 조회
export const getEtcInvoice = (idx) => {
  return new Promise((resolve, reject) => {
    http
      .get(`/etcInvoice/${idx}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 견적서/발주서 수정
export const modifyEtcInvoice = (idx, body) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/etcInvoice/${idx}`, body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 견적서 발주서 삭제
export const deleteEtcInvoice = (idx) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/etcInvoice/${idx}`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 견적서/발주서 거래명세서 매핑 삭제
export const deleteInvoiceMappingEtcInvoice = (data) => {
  return new Promise((resolve, reject) => {
    http
      .delete('/etcInvoice/mapping/invoices', { data })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 견적서/발주서 일괄매핑
export const mappingToEtcInvoice = (type, requesterType, params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/etcInvoice/mapping/${type}/${requesterType}`, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const deleteToEtcInvoice = (type, data) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/etcInvoice/mapping/${type}`, { data })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const sendMail = (type, params) => {
  switch (type) {
    case "etcInvoice":
      return new Promise((resolve, reject) => {
        http
          .post(`/etcInvoice/sendMail`, params)
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });

    case "invoice":
      return new Promise((resolve, reject) => {
        http
          .post(`/invoices/sendMail`, params)
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    default:
      break;
  }
};

export const directTaxInvoice = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/tax-invoices/direct", body)
      .then((res) => {
        toast.success("종이(세금)계산서가 발행되었습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const directEditTaxInvoice = (idx, body) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/tax-invoices/direct/${idx}`, body)
      .then((res) => {
        toast.success("종이(세금)계산서가 수정 발행되었습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const directDeleteTaxInvoice = (data) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/tax-invoices/direct`, { data })
      .then((res) => {
        toast.success("종이(세금)계산서가 삭제되었습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const excelUploadTaxInvoice = (type, tax, file) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/tax-invoices/excelupload/${type}/${tax}`, file)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};